import React, { useState, useEffect } from "react";
import { Button } from "primereact/button";

export default function ScrollTopButton() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const toggleVisibility = () => {
      if (window.scrollY > 300) {
        setVisible(true);
      } else {
        setVisible(false);
      }
    };

    window.addEventListener("scroll", toggleVisibility);

    return () => window.removeEventListener("scroll", toggleVisibility);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth"
    });
  };

  return (
    <>
      {visible && (
       <Button
  icon="pi pi-arrow-up"
  className="scroll-top-btn p-button-rounded"
  onClick={scrollToTop}
/>
      )}
    </>
  );
}
